import { render, staticRenderFns } from "./Wage.vue?vue&type=template&id=cd5da840"
import script from "./Wage.vue?vue&type=script&lang=js"
export * from "./Wage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports